import React, { useState } from 'react'
import setting from '../assets/setting.svg'
import setting_forecast from '../assets/setting_forecast.svg'
import '../pages/ant_custom.less'
import ContractDropDown from './ContractDropDown';
import PopupEdit from './PopupEdit';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import SettingsIcon from '@mui/icons-material/Settings';
import PopupDelete from './PopupDelete';
import { makeStyles } from '@mui/styles';

function DropSection({ taskID,expanded ,expenseFormatted, budgetFormatted, mainBudget, refresh, setRefresh, setOpenPopup, openPopup, setLoading, category }) {
    const [contract, setContract] = useState(true);
    const [name, setName] = useState('');
    const [value, setValue] = useState(0);
    const [mainID, setMainID] = useState('');
    const [id, setId] = useState('');
    const [confirm, setConfirm] = useState(false);
 
    const useStyles = makeStyles({
        customIcon: {
          color: '#98d2c2 !important',
          width: '20px',
            height: '23px',
        },
        customIcon1:{
            color: '#98bcd6 !important',
          width: '21px',
            height: '20px',
        }
      });
      

      const classes = useStyles();
    const genExtra = (entry, forecast) => (
        <div style={{display:'flex', flexDirection:'row', width:'45px'}} >
        
        <div
            style={{position: 'relative',top: '0px', flex:'1'}}
            onClick={(event) => {
                console.log(entry)
                if (forecast) {
                    setContract(false)
                    setName(entry.BudgetLineName)
                    setId(entry.BudgetLineID)
                    setValue(entry.Value)
                    setMainID(entry.MainBudgetLineID)
                } else {
                    setContract(true)
                    setName(entry.MainBudgetLineName)
                    setId(entry.MainBudgetLineID)
                    setValue(entry.Value)
                }
                setOpenPopup(true)
                // If you don't want click extra trigger collapse, you can prevent this:
                event.stopPropagation();
            }}
        >
            <SettingsIcon
                className={forecast ? classes.customIcon1 : classes.customIcon}
            />
        </div>
    
        <div onClick={(event)=>{console.log(entry)
                if (forecast) {
                    setContract(false)
                    setName(entry.BudgetLineName)
                    setId(entry.BudgetLineID)
                    setValue(entry.Value)
                    setMainID(entry.MainBudgetLineID)
                } else {
                    setContract(true)
                    setName(entry.MainBudgetLineName)
                    setId(entry.MainBudgetLineID)
                    setValue(entry.Value)
                }
                setConfirm(true)
                // If you don't want click extra trigger collapse, you can prevent this:
                event.stopPropagation();}}
                  style={{position: 'relative',top: '0px', flex:'1'}}>
              
                <DeleteOutlineIcon
           className={forecast ? classes.customIcon1 : classes.customIcon}
           /> 
  
           
        </div>
        </div>
        
    );
    return (
        <>
            <PopupDelete 
                refresh={refresh}
                setRefresh={setRefresh}
                setOpenPopup={setConfirm}
                id={id}
                contract={contract}
                mainID={mainID}
                name={name}
                openPopup={confirm}
                setLoading={setLoading}
                taskID={taskID}
            />

            <PopupEdit
                refresh={refresh}
                setRefresh={setRefresh}
                setOpenPopup={setOpenPopup}
                openPopup={openPopup}
                contract={contract}
                value={value}
                name={name}
                id={id}
                mainID={mainID}
                mainBudget={mainBudget}
                setLoading={setLoading}
                category={category}
                taskID={taskID}
            />
            
            {mainBudget.map((entry, index) => {
                return <ContractDropDown
                    expanded={expanded}
                    genExtra={genExtra}
                    entry={entry}
                    setName={setName}
                    setValue={setValue}
                    setMainID={setMainID}
                    expenseFormatted={expenseFormatted}
                    budgetFormatted={budgetFormatted}
                    refresh={refresh}
                    setRefresh={setRefresh}
                    openPopup={openPopup}
                    setOpenPopup={setOpenPopup}
                    contracted={entry.Value}
                    forecasted={budgetFormatted[entry.MainBudgetLineID+''].reduce((a, b) => a + (b['Value'] || 0), 0)}
                    spent={budgetFormatted[entry.MainBudgetLineID+''].reduce((a, b) => {
                        return a + (expenseFormatted[b.BudgetLineID+''].reduce((a, b) => a + (b['Input'] || 0), 0) || 0)
                     }, 0)}
                />
            })}

            { budgetFormatted['Unlinked'].length > 0 ? 
            <ContractDropDown
            expanded={expanded}
                entry={{ MainBudgetLineName: 'Unlinked Forecasts', MainBudgetLineID: 'Unlinked' , Value: 0}}
                expenseFormatted={expenseFormatted}
                budgetFormatted={budgetFormatted}
                genExtra={genExtra} 
                contracted={0}
                forecasted={budgetFormatted['Unlinked'].reduce((a, b) => a + (b['Value'] || 0), 0)}
                spent={budgetFormatted['Unlinked'].reduce((a, b) => {
                        return a + (expenseFormatted[b.BudgetLineID+''].reduce((a, b) => a + (b['Input'] || 0), 0) || 0)
                     }, 0)}
                />
                : ''}
                
        </>
    )
}

export default DropSection